// extracted by mini-css-extract-plugin
export var textInput = "_kp-0";